import { Box, BoxProps } from '@chakra-ui/react/box';
import { Text } from '@chakra-ui/react/text';
import { ReactNode } from 'react';

type HorizontalRulerWithContentProps = BoxProps & {
  children: ReactNode;
};

const HorizontalRulerWithContent = ({ children, ...rest }: HorizontalRulerWithContentProps) => (
  <Box display="flex" alignItems="center">
    <Box display="flex" height="1px" backgroundColor="interactive/disabled" flexGrow={1} {...rest} />
    {typeof children === 'string' ? (
      <Text textStyle="body/md/regular" paddingX="8">
        {children}
      </Text>
    ) : (
      children
    )}
    <Box display="flex" height="1px" backgroundColor="interactive/disabled" flexGrow={1} {...rest} />
  </Box>
);

export default HorizontalRulerWithContent;
